import { Forms } from "../../../components";
import { IResponse } from "../../../services/model";

export default class Service<T> {
  /** Formulario principal */
  form: Forms.Form = new Forms.Form();

  /** Devuelve la entidad */
  getEntity: () => IResponse<T>;

  private getEntityBase = () => {
    if (!this.form.isFormValid())
      return { success: false, error: (this.form.getStatus().errors ?? [])[0] }
    return { success: true, data: this.form.getEntity() }
  };

  constructor(getEntity?: () => IResponse<T>) {
    this.getEntity = getEntity ?? this.getEntityBase;
  }

  /** compatibilidad con form */
  add = (control: any, field: string, validate?: () => string | undefined) => this.form.add(control, field, validate);
  setValue = (field: string, value: any, error?: string) => this.form.setValue(field, value, error);
  setEntity = (entity: any) => this.form.setEntity(entity);
  isFormValid = () => this.form.isFormValid();
  getStatus = () => this.form.getStatus();

  getFormEntity = (mapping?: (dto:T) => IResponse<T>) => {
    var isValid = this.isFormValid();
    if (!isValid) {
      return { success: false, error: (this.getStatus().errors ?? [])[0] };
    } else {
      const dto = this.form.getEntity() as T;
      let res = { success: true, data: dto } as IResponse<T>;
      if (mapping) res = mapping(dto);
      return res;
    }
  }
}